export var AudioPlaybackDelta;
(function (AudioPlaybackDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["AUDIO_PLAYBACK_DELTA"] = "audio_playback_delta";
    })(type = AudioPlaybackDelta.type || (AudioPlaybackDelta.type = {}));
})(AudioPlaybackDelta || (AudioPlaybackDelta = {}));
